import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const ServiceContent = [
  {
    icon: "icon_08",
    title: "School ERP",
    desc: `Automation of all the manual tasks such as attendance, grade and report card management, timetables, exam schedules, fees records, hostels, and library details.`,
    arrow: "icon_13",
    dataAos: "fade-up",
    dataDelay: "100",
    col: "col-lg-4 col-sm-6",
  },
  {
    icon: "icon_09",
    title: "E-Learning",
    desc: `Today people first search for their queries on the internet rather than looking for books or asking someone. Hence, this has led to the Importance of E-Learning in Education.`,
    arrow: "icon_13",
    dataAos: "fade-up",
    dataDelay: "200",
    col: "col-lg-4 col-sm-6",
  },
  {
    icon: "icon_10",
    title: "Live Classes",
    desc: `Login, Enroll and watch all the live content.`,
    arrow: "icon_13",
    dataAos: "fade-up",
    dataDelay: "100",
    col: "col-lg-4 col-sm-6",
  },
  {
    icon: "icon_11",
    title: "Recorded Sessions",
    desc: `Variety or content can be uploaded and used by all the registered customers.`,
    arrow: "icon_13",
    dataAos: "fade-up",
    dataDelay: "200",
    col: "col-lg-4 col-sm-6",
  },
  {
    icon: "icon_12",
    title: "Statistical Modeling",
    desc: `You can discover hidden opportunities collecting, analyzing or explaining your data in a different way.`,
    arrow: "icon_13",
    fadeUp: "fade-up",
    dataDelay: "300",
    col: "col-lg-4",
  },
];

const FancyFeatureFour = () => {
  return (
    <Fragment>
      {ServiceContent.map((val, i) => (
        <div
          key={i}
          className={`${val.col} mt-40 d-flex`}
          data-aos={val.fadeUp}
          data-aos-delay={val.dataDelay}
        >
          <div className="block-style-four">
            <div className="icon d-flex align-items-end justify-content-center">
              <img src={`images/icon/${val.icon}.svg`} alt="" />
            </div>
            <Link to="">
              <h5>{val.title}</h5>
            </Link>
            <p>{val.desc}</p>
            {/* <Link to="/service-one" className="more-btn">
              <img
                src={`images/icon/${val.arrow}.svg`}
                alt=""
                className="tran3s"
              />
            </Link> */}
          </div>
          {/* /.block-style-four */}
        </div>
      ))}
    </Fragment>
  );
};

export default FancyFeatureFour;
